var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFluxo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.58,
    height: 50,
    viewBox: "0 0 50.58 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-fluxo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "losango"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1329",
    "data-name": "Caminho 1329",
    d: "M12.68,20.16,7,24.19l-5.64-4,5.64-4Z",
    style: {
      fill: "#fdd76f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1330",
    "data-name": "Caminho 1330",
    d: "M35.26,33.07l-6.45,4-6.45-4,6.45-4Z",
    style: {
      fill: "#fdd76f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "retangulos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1327",
    "data-name": "Caminho 1327",
    d: "M36.06,44.36v3.22a1.61,1.61,0,0,1-1.61,1.61H23.16a1.61,1.61,0,0,1-1.61-1.61V44.36a1.62,1.62,0,0,1,1.61-1.62H34.45A1.61,1.61,0,0,1,36.06,44.36Z",
    style: {
      fill: "#70c1aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1328",
    "data-name": "Caminho 1328",
    d: "M33.64,17.74v4.84H24V17.74Z",
    style: {
      fill: "#e6e9ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1331",
    "data-name": "Caminho 1331",
    d: "M35.26.81v9.67H22.35V.81Z",
    style: {
      fill: "#f1d0b4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "elipse"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_48",
    "data-name": "Elipse 48",
    cx: 7.03,
    cy: 45.97,
    r: 1.61,
    style: {
      fill: "#ef7f70"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_49",
    "data-name": "Elipse 49",
    cx: 48.16,
    cy: 5.64,
    r: 1.61,
    style: {
      fill: "#ef7f70"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_50",
    "data-name": "Elipse 50",
    cx: 48.16,
    cy: 33.06,
    r: 1.61,
    style: {
      fill: "#ef7f70"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sobreposicoes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1332",
    "data-name": "Caminho 1332",
    d: "M34.45,41.93H29.61V37.54l7.17-4.47-7.17-4.49v-5.2h4.84V16.93H29.61V11.29h6.45V0H21.55V11.29H28v5.64H23.16v2.43H15.91V21h7.25v2.42H28v5.2l-7.16,4.48L28,37.55v4.39H23.16a2.42,2.42,0,0,0-2.42,2.42v3.22A2.43,2.43,0,0,0,23.16,50H34.45a2.42,2.42,0,0,0,2.42-2.42h0V44.35A2.42,2.42,0,0,0,34.45,41.93ZM23.16,9.68V1.61H34.45V9.68Zm1.61,12.1V18.55h8.07v3.23Zm-.9,11.29L28.8,30l4.93,3.08L28.8,36.15ZM35.26,47.58a.81.81,0,0,1-.81.81H23.16a.81.81,0,0,1-.81-.81V44.36a.81.81,0,0,1,.81-.81H34.45a.81.81,0,0,1,.81.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1333",
    "data-name": "Caminho 1333",
    d: "M14.53,43.31l1.85,1.85H9.3A2.4,2.4,0,0,0,7.84,43.7V26.61H6.23V43.7a2.41,2.41,0,1,0,1.6,4.55A2.38,2.38,0,0,0,9.3,46.78h7.08l-1.85,1.85,1.14,1.14,3.8-3.8-3.8-3.8ZM7,46.77a.81.81,0,1,1,.81-.8h0a.8.8,0,0,1-.81.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1334",
    "data-name": "Caminho 1334",
    d: "M49,30.79V7.92a2.42,2.42,0,0,0-1.6-4.56,2.44,2.44,0,0,0-1.48,1.48H37.68V6.45h8.21a2.46,2.46,0,0,0,1.47,1.47V30.79a2.46,2.46,0,0,0-1.47,1.47H40.43l1.85-1.85-1.14-1.14-3.8,3.8,3.8,3.79,1.14-1.14-1.85-1.85h5.46a2.41,2.41,0,1,0,4.55-1.6A2.38,2.38,0,0,0,49,30.8ZM48.16,4.84a.81.81,0,1,1-.8.81h0a.8.8,0,0,1,.8-.81Zm0,29a.81.81,0,1,1,.81-.81h0a.8.8,0,0,1-.81.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1335",
    "data-name": "Caminho 1335",
    d: "M14.07,20.16l-7-5-7,5,7,5Zm-7-3,4.26,3L7,23.2l-4.25-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1336",
    "data-name": "Caminho 1336",
    d: "M24.77,3.23h8.07V4.84H24.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1337",
    "data-name": "Caminho 1337",
    d: "M24.77,6.45h4.84V8.07H24.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1338",
    "data-name": "Caminho 1338",
    d: "M31.23,6.45h1.61V8.07H31.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1339",
    "data-name": "Caminho 1339",
    d: "M38.48,45.16H40.1v1.61H38.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1340",
    "data-name": "Caminho 1340",
    d: "M41.71,45.16h1.61v1.61H41.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1341",
    "data-name": "Caminho 1341",
    d: "M44.94,45.16h1.61v1.61H44.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1342",
    "data-name": "Caminho 1342",
    d: "M18.32,6.45h1.62V8.07H18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1343",
    "data-name": "Caminho 1343",
    d: "M11.87,6.45h1.61V8.07H11.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1344",
    "data-name": "Caminho 1344",
    d: "M15.1,6.45h1.61V8.07H15.1Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFluxo);
export default __webpack_public_path__ + "static/media/ico-fluxo.73465e43.svg";
export { ForwardRef as ReactComponent };